import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';

var Navigation = function Navigation(_ref) {
  var children = _ref.children;
  return React.createElement(
    'div',
    { className: styles.navigation, 'data-hook': 'menu-navigation' },
    children
  );
};

Navigation.propTypes = {
  children: PropTypes.node
};

export default Navigation;
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/SideMenu/core/navigation/index.js